import { useAbility } from '@cast/shared-ability-data-access';

export const useCanCreatePolicy = () => ({
  canCreatePolicy: useAbility().can('create', 'ClusterWorkloadAutoscaler'),
});
